"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SessionStateControllerAction_1 = require("./SessionStateControllerAction");

var SessionStateControllerDeferPriority_1 = require("./SessionStateControllerDeferPriority");

var SessionStateControllerState_1 = require("./SessionStateControllerState");

var SessionStateControllerTransitionResult_1 = require("./SessionStateControllerTransitionResult");

var DefaultSessionStateController = /*#__PURE__*/function () {
  function DefaultSessionStateController(logger) {
    _classCallCheck(this, DefaultSessionStateController);

    this.logger = logger;
    this.currentState = SessionStateControllerState_1.SessionStateControllerState.NotConnected;
    this.deferredAction = null;
    this.deferredWork = null;
  }

  _createClass(DefaultSessionStateController, [{
    key: "perform",
    value: function perform(action, work) {
      var state = this.currentState;

      if (state === SessionStateControllerState_1.SessionStateControllerState.NotConnected && action === SessionStateControllerAction_1.SessionStateControllerAction.Connect) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Connecting, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Connecting && action === SessionStateControllerAction_1.SessionStateControllerAction.Fail) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Disconnecting, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Connecting && action === SessionStateControllerAction_1.SessionStateControllerAction.FinishConnecting) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Connected, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Connected && action === SessionStateControllerAction_1.SessionStateControllerAction.Disconnect) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Disconnecting, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Connected && action === SessionStateControllerAction_1.SessionStateControllerAction.Reconnect) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Connecting, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Connected && action === SessionStateControllerAction_1.SessionStateControllerAction.Fail) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Disconnecting, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Connected && action === SessionStateControllerAction_1.SessionStateControllerAction.Update) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Updating, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Updating && action === SessionStateControllerAction_1.SessionStateControllerAction.Fail) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Disconnecting, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Updating && action === SessionStateControllerAction_1.SessionStateControllerAction.FinishUpdating) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.Connected, action);
      } else if (state === SessionStateControllerState_1.SessionStateControllerState.Disconnecting && action === SessionStateControllerAction_1.SessionStateControllerAction.FinishDisconnecting) {
        this.transition(SessionStateControllerState_1.SessionStateControllerState.NotConnected, action);
      } else if (this.canDefer(action)) {
        this.logger.info("deferring transition from ".concat(SessionStateControllerState_1.SessionStateControllerState[this.currentState], " with ").concat(SessionStateControllerAction_1.SessionStateControllerAction[action]));
        this.deferAction(action, work);
        return SessionStateControllerTransitionResult_1.SessionStateControllerTransitionResult.DeferredTransition;
      } else {
        this.logger.warn("no transition found from ".concat(SessionStateControllerState_1.SessionStateControllerState[this.currentState], " with ").concat(SessionStateControllerAction_1.SessionStateControllerAction[action]));
        return SessionStateControllerTransitionResult_1.SessionStateControllerTransitionResult.NoTransitionAvailable;
      }

      try {
        work();
      } catch (e) {
        this.logger.error("error during state ".concat(SessionStateControllerState_1.SessionStateControllerState[this.currentState], " with action ").concat(SessionStateControllerAction_1.SessionStateControllerAction[action], ": ").concat(e));
        this.logger.info("rolling back transition to ".concat(SessionStateControllerState_1.SessionStateControllerState[state]));
        this.currentState = state;
        return SessionStateControllerTransitionResult_1.SessionStateControllerTransitionResult.TransitionFailed;
      }

      this.performDeferredAction();
      return SessionStateControllerTransitionResult_1.SessionStateControllerTransitionResult.Transitioned;
    }
  }, {
    key: "state",
    value: function state() {
      return this.currentState;
    }
  }, {
    key: "transition",
    value: function transition(newState, action) {
      this.logger.info("transitioning from ".concat(SessionStateControllerState_1.SessionStateControllerState[this.currentState], " to ").concat(SessionStateControllerState_1.SessionStateControllerState[newState], " with ").concat(SessionStateControllerAction_1.SessionStateControllerAction[action]));
      this.currentState = newState;
    }
  }, {
    key: "deferPriority",
    value: function deferPriority(action) {
      switch (action) {
        case SessionStateControllerAction_1.SessionStateControllerAction.Disconnect:
          return SessionStateControllerDeferPriority_1.SessionStateControllerDeferPriority.VeryHigh;

        case SessionStateControllerAction_1.SessionStateControllerAction.Fail:
          return SessionStateControllerDeferPriority_1.SessionStateControllerDeferPriority.High;

        case SessionStateControllerAction_1.SessionStateControllerAction.Reconnect:
          return SessionStateControllerDeferPriority_1.SessionStateControllerDeferPriority.Medium;

        case SessionStateControllerAction_1.SessionStateControllerAction.Update:
          return SessionStateControllerDeferPriority_1.SessionStateControllerDeferPriority.Low;

        default:
          return SessionStateControllerDeferPriority_1.SessionStateControllerDeferPriority.DoNotDefer;
      }
    }
  }, {
    key: "deferAction",
    value: function deferAction(action, work) {
      if (this.deferredAction !== null && this.deferPriority(this.deferredAction) > this.deferPriority(action)) {
        return;
      }

      this.deferredAction = action;
      this.deferredWork = work;
    }
  }, {
    key: "canDefer",
    value: function canDefer(action) {
      return this.deferPriority(action) !== SessionStateControllerDeferPriority_1.SessionStateControllerDeferPriority.DoNotDefer && (this.currentState === SessionStateControllerState_1.SessionStateControllerState.Connecting || this.currentState === SessionStateControllerState_1.SessionStateControllerState.Updating);
    }
  }, {
    key: "performDeferredAction",
    value: function performDeferredAction() {
      if (!this.deferredAction) {
        return;
      }

      var deferredAction = this.deferredAction;
      var deferredWork = this.deferredWork;
      this.deferredAction = null;
      this.deferredWork = null;
      this.logger.info("performing deferred action ".concat(SessionStateControllerAction_1.SessionStateControllerAction[deferredAction]));

      if (this.perform(deferredAction, deferredWork) !== SessionStateControllerTransitionResult_1.SessionStateControllerTransitionResult.Transitioned) {
        this.logger.info("unable to perform deferred action ".concat(SessionStateControllerAction_1.SessionStateControllerAction[deferredAction], " in state ").concat(SessionStateControllerState_1.SessionStateControllerState[this.currentState]));
      }
    }
  }]);

  return DefaultSessionStateController;
}();

exports.default = DefaultSessionStateController;